export const getBasePrice = ({netQuantityContent, contentUnit, basePrice, priceCurrencySymbol, basePriceQuantity, basePriceUnit}) => {
    if(!netQuantityContent || !contentUnit || !basePrice || !priceCurrencySymbol || !basePriceQuantity || !basePriceUnit){
        return "";
    }
    return `${netQuantityContent} ${contentUnit} (${basePrice} ${priceCurrencySymbol} je ${basePriceQuantity} ${basePriceUnit})`;
}